import { Dash } from '@mews-commander/ui';
import { BillLinkWithBillId } from './BillLinkWithBillId';
import { BillLinkWithOrderItemId } from './BillLinkWithOrderItemId';

interface BillLinkBaseProps {
    groupId?: string;
}

interface BillLinkWithBillIdProps {
    billId: string;
    orderItemId?: never;
}

interface BillLinkWithOrderItemIdProps {
    billId?: never;
    orderItemId: string;
}

type BillLinkProps = (BillLinkWithBillIdProps | BillLinkWithOrderItemIdProps) & BillLinkBaseProps;

export const BillLink = ({ billId, orderItemId, groupId }: BillLinkProps) => {
    if (billId) {
        return <BillLinkWithBillId billId={billId} groupId={groupId} />;
    }
    if (orderItemId) {
        return <BillLinkWithOrderItemId orderItemId={orderItemId} groupId={groupId} />;
    }

    return <Dash />;
};
